/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Pricing_Included_In_AppInputs */



/**
* | output |
* | --- |
* | "in the app (not on Gateway)" |
*
* @param {Model_Pricing_Included_In_AppInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_pricing_included_in_app = /** @type {((inputs?: Model_Pricing_Included_In_AppInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Pricing_Included_In_AppInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("in der App (nicht bei Gateway)")
	return /** @type {LocalizedString} */ ("in the app (not on Gateway)")
});